//App

import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { TemplateApiType } from "./types/apiTypes";

const templateApi: TemplateApiType = {
    getEmailTemplate: (value) => apiClient.get(endPoints.template.getEmailTemplate(value)),
    getEmailTemplates: (payload) => apiClient.get(endPoints.template.getEmailTemplates(payload)),
    saveEmailTemplate: (payload) => apiClient.post(endPoints.template.saveEmailTemplate(), payload),
};

export default templateApi;